import React from "react";

import logo from "../assets/logos/logo-atelier-pixel.png";

const HomePage = () => {
	return (
		<div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 px-6 text-center">
			<img src={logo} alt="Logo" className=" h-32 mb-12" />
			<div className="bg-white p-8 rounded-3xl shadow-md">
				<h1 className="text-2xl font-bold text-gray-800">
					Bienvenue sur notre plateforme !
				</h1>
				<p className="mt-4 text-gray-600">
					Vous semblez être sur la page d'accueil, mais il n'y a pas de quiz
					actif ici.
				</p>
				<p className="mt-2 text-gray-600">
					Si vous essayez d'accéder à un quiz, veuillez contacter votre
					administrateur.
				</p>
				<p className="mt-2 text-gray-600 mb-12">
					Vous souhaitez créer un quiz pour votre organisation ? Faites-nous une
					demande !
				</p>
				<a
					href="mailto:kerwan.verot@atelier-pixel.fr?subject=Demande de création de quiz"
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Demander la création d’un quiz
				</a>
			</div>
		</div>
	);
};

export default HomePage;
